// Static content for Désir Events (LIGHT / commercial direction)

export const LOGO = {
  wordmark:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_event-positioning/artifacts/rrnlx9hg_Logo-3-DE-texte-noir-vert.png",
  iconDark:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_event-positioning/artifacts/iaa1ksqr_Logo-3-DE-pomme-noir-vert.png",
  iconLight:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_event-positioning/artifacts/m6ubzob9_Logo-3-DE-pomme-blanc-vert.png",
};

export const IMAGES = {
  hero: "/images/hero.webp",
  heroSalon: "/images/hero-salon.webp",
  heroTeamBuilding: "/images/hero-teambuilding.webp",
  productLaunch: "/images/lancement.webp",
  boutique: "/images/boutique.webp",
  gala: "/images/gala.webp",
  commercial: "/images/seminaire.webp",
};

export const CONTACT = {
  brand: "Désir Events",
  legalName: "DESIREVENT 2.0",
  siret: "877 771 550 00010",
  email: "contact@desir-events.com",
  phoneFixe: "04 65 84 86 37",
  phoneMobile: "06 45 06 65 68",
  address: "129 rue de Servient, 69003 Lyon",
  building: "Tour Part-Dieu — 21e étage",
  zones: "Lyon • Paris • Valence — Intervention France entière",
  availability: "Contact téléphonique 7j/7 · étude sous 24 h ouvrées",
  hostessSite: "https://hotesses-events.fr",
  cleaningSite: "https://nettoyage69.fr",
};

// Sister brands & partner network — always presented as "Désir Events coordinates, partners execute"
export const PARTNERS = [
  {
    name: "Hôtesses Events",
    domain: "hotesses-events.fr",
    url: "https://hotesses-events.fr",
    category: "Hôtes & hôtesses d'accueil",
    role: "Personnel événementiel : accueil, promotion, distribution, animation.",
  },
  {
    name: "Renforteo",
    domain: "renforteo.fr",
    url: "https://renforteo.fr",
    category: "Personnel événementiel",
    role: "Renfort en personnel qualifié pour vos événements haute affluence.",
  },
  {
    name: "Désir & Gourmandise",
    domain: "gourmandise-traiteur.fr",
    url: "https://www.gourmandise-traiteur.fr",
    category: "Traiteur événementiel",
    role: "Cocktails, dîners, buffets — gastronomie française et créative.",
  },
  {
    name: "Conciergerie Désir",
    domain: "congiergerie-desir.fr",
    url: "https://www.congiergerie-desir.fr",
    category: "Conciergerie & VIP",
    role: "Service premium sur-mesure pour vos invités et collaborateurs.",
  },
  {
    name: "Désir Propreté",
    domain: "nettoyage69.fr",
    url: "https://www.nettoyage69.fr",
    category: "Nettoyage professionnel",
    role: "Remise en état post-événement et nettoyage régulier de bureaux.",
  },
];

// Trust references (client brand wordmarks) — requested by client
export const SERVICES = [
  {
    slug: "lancements-produits",
    title: "Lancements de produits",
    tagline: "Créer l'événement autour de votre nouveauté.",
    short:
      "Des révélations produit spectaculaires qui créent le désir, marquent la presse et boostent vos ventes.",
    image: IMAGES.productLaunch,
    intro:
      "Un lancement réussi transforme un produit en événement. Nous concevons des révélations à fort impact commercial : scénographie, storytelling de marque et amplification média pour maximiser vos retombées.",
    deliverables: [
      "Concept créatif et storytelling produit",
      "Mapping vidéo, effets scéniques et démonstrations",
      "Parcours expérientiel & essais pour la presse",
      "Relations presse, influenceurs et partenaires",
      "Captation, contenus et amplification digitale",
    ],
  },
  {
    slug: "inaugurations-boutiques",
    title: "Inaugurations & Boutiques",
    tagline: "Ouvrir en beauté, faire venir le monde.",
    short:
      "Ouvertures de boutique, inaugurations et poses de première pierre pensées pour attirer clients et notoriété.",
    image: IMAGES.boutique,
    intro:
      "Une ouverture ne se réussit qu'une fois. Nous orchestrons des inaugurations et ouvertures de boutique qui font affluer clients, presse et partenaires, et installent durablement votre enseigne.",
    deliverables: [
      "Concept d'ouverture et scénographie vitrine",
      "Animation commerciale et trafic en boutique",
      "Cocktail, DJ set et programme d'accueil VIP",
      "Invitations presse, influenceurs et riverains",
      "Photo/vidéo et relais réseaux sociaux",
    ],
  },
  {
    slug: "soirees-galas",
    title: "Soirées & Galas",
    tagline: "L'art de recevoir, magnifié.",
    short:
      "Dîners de gala, soirées clients et cérémonies de prestige, jusque dans le moindre détail.",
    image: IMAGES.gala,
    intro:
      "Une soirée d'entreprise réussie laisse une empreinte durable. Nous orchestrons des galas où chaque détail — de l'accueil au dessert — raconte votre marque.",
    deliverables: [
      "Recherche et privatisation de lieux d'exception",
      "Scénographie, décoration et mise en lumière",
      "Traiteur gastronomique et accords mets-vins",
      "Programmation artistique et animations live",
      "Coordination du jour J et régie générale",
    ],
  },
  {
    slug: "seminaires-conventions",
    title: "Séminaires & Conventions",
    tagline: "Rassembler, aligner, inspirer.",
    short:
      "Des conventions d'entreprise à fort impact, du plénier spectaculaire aux ateliers collaboratifs.",
    image: "/images/seminaires.webp",
    intro:
      "Le séminaire est le moment où votre stratégie devient collective. Nous concevons des conventions qui alignent vos équipes autour d'un cap commun, avec une exécution millimétrée.",
    deliverables: [
      "Conception du fil rouge et de la scénographie",
      "Régie technique complète (son, lumière, vidéo)",
      "Gestion des intervenants et du timing plénier",
      "Ateliers, break-out sessions et animations",
      "Logistique invités, transport et hébergement",
    ],
  },
  {
    slug: "team-building",
    title: "Team Building",
    tagline: "Souder les équipes, autrement.",
    short:
      "Des expériences collectives qui renforcent la cohésion et l'engagement de vos collaborateurs.",
    image: "/images/soiree.webp",
    intro:
      "Le team building n'est pas un jeu, c'est un investissement. Nous créons des expériences sur-mesure qui reconnectent vos équipes et servent vos objectifs RH.",
    deliverables: [
      "Ateliers créatifs, sportifs ou solidaires",
      "Challenges immersifs et grands jeux",
      "Séjours cohésion multi-jours clé en main",
      "Animations RSE et engagement citoyen",
      "Mesure de l'impact et restitution",
    ],
  },
  {
    slug: "conferences-congres",
    title: "Conférences & Congrès",
    tagline: "L'organisation au service du savoir.",
    short:
      "Congrès, conventions scientifiques et conférences professionnelles, de 100 à 5 000 participants.",
    image: IMAGES.hero,
    intro:
      "Un congrès, c'est une logistique de haute précision au service de l'échange. Nous gérons l'ensemble de la chaîne, de l'inscription à la régie plénière.",
    deliverables: [
      "Plateforme d'inscription et billetterie",
      "Gestion des intervenants et du programme",
      "Régie multi-salles et interprétariat",
      "Espaces exposants et networking",
      "Accueil, badges et hospitality congressistes",
    ],
  },
  {
    slug: "fetes-noel-entreprise",
    title: "Fêtes de Noël d'entreprise",
    tagline: "Célébrer l'année, fédérer les équipes.",
    short:
      "Arbres de Noël, soirées de fin d'année et cocktails entreprises — festifs, chaleureux, mémorables.",
    image: "/images/conference.webp",
    intro:
      "La fête de Noël d'entreprise est le rendez-vous fédérateur de l'année. Nous concevons des soirées de fin d'année qui récompensent vos collaborateurs et resserrent les liens : arbre de Noël pour les enfants, dîner de gala pour les équipes, soirée dansante ou spectacle sur-mesure.",
    deliverables: [
      "Scénographie et décoration festive premium",
      "Arbre de Noël enfants (spectacle, ateliers, Père Noël)",
      "Dîner de fête, cocktail dînatoire ou brunch",
      "DJ, live music, spectacles et animations",
      "Cadeaux personnalisés, photobooth et souvenirs",
    ],
  },
  {
    slug: "voyages-incentives",
    title: "Voyages & Incentives à l'étranger",
    tagline: "Récompenser autrement, voyager ensemble.",
    short:
      "Team building et incentives à l'étranger : Maroc, Antilles, Canada, Espagne, Belgique, Suisse, Croatie — organisation clé en main.",
    image: "/images/voyage.webp",
    intro:
      "Un voyage d'entreprise réussi est un investissement humain qui marque durablement. Nous organisons vos séminaires, incentives et team building à l'international : Maroc (Marrakech, Essaouira), Antilles (Guadeloupe, Martinique), Canada (Québec, Montréal), Espagne (Barcelone, Madrid, Ibiza), Belgique (Bruxelles), Suisse (Genève, Zermatt), Croatie (Split, Dubrovnik). De la logistique aérienne aux expériences terrain, tout est piloté par nos équipes.",
    deliverables: [
      "Recherche destination, hôtels 4/5★ et privatisations",
      "Vols groupe, transferts et logistique VIP",
      "Programmes team building outdoor et culturels",
      "Soirées thématiques, gala et animations locales",
      "Coordinateur dédié sur place 24/7 et retour d'expérience",
    ],
  },
];

export const SECTEURS = [
  { name: "Retail & Boutiques", desc: "Ouvertures, animations commerciales et pop-up stores qui font venir le monde." },
  { name: "Luxe & Mode", desc: "Défilés, soirées de collection et expériences clients haut de gamme." },
  { name: "Tech & Startups", desc: "Keynotes, lancements et conventions pour les acteurs de l'innovation." },
  { name: "Finance & Banque", desc: "Conventions, roadshows investisseurs et soirées de prestige." },
  { name: "Automobile & Mobilité", desc: "Présentations de modèles, essais et activations expérientielles." },
  { name: "Immobilier & Luxe", desc: "Inaugurations, avant-premières et événements de commercialisation." },
];

export const CITIES = [
  { slug: "paris", name: "Paris" },
  { slug: "lyon", name: "Lyon" },
  { slug: "marseille", name: "Marseille" },
  { slug: "bordeaux", name: "Bordeaux" },
  { slug: "lille", name: "Lille" },
];
